export default __webpack_public_path__ + "static/media/Pat-Madden.9729e1c4.png";